import firebase from 'firebase/compat/app';
import emailjs from '@emailjs/browser';
import * as actionConstants from '../actionConstants';
const axios = require('axios');

export const getUser = () => async dispatch => {
  dispatch({ type: actionConstants.LOADING_USER });
  let currentUser = await firebase.auth().currentUser;

  return firebase
    .firestore()
    .collection('users')
    .doc(currentUser.uid)
    .get()
    .then(doc => {
      dispatch({ type: actionConstants.LOADED_USER, payload: {id: doc.id, ...doc.data()}})
    })
    .catch(error => console.log(error))

};

export const clearAddedUser = () => dispatch => {
  dispatch({type: actionConstants.CLEAR_ADDED_USER})
}

export const getUsers = () => async (dispatch, getState) => {
  dispatch({ type: actionConstants.LOADING_USERS });
  let currentUser = await firebase.auth().currentUser;

  if (getState().user.user.type === 'super') {
    return firebase
    .firestore()
    .collection('users')
    .get()
    .then(querySnapshot => {
      let users = [];
      querySnapshot.forEach(doc => {
        if (doc.data()?.type !== 'tenant') {
          users.push({id: doc.id, ...doc.data()})
        }
      })
      dispatch({ type: actionConstants.LOADED_USERS, payload: users})
    })
    .catch(error => console.log(error))
  } else if (getState().user.user.type === 'regional') {
    // Regional admins can only see other regional admins and enforcement officers from their client
    return firebase
      .firestore()
      .collection('users')
      .where('client', '==', getState().user.user.client)
      .get()
      .then(querySnapshot => {
        let users = [];
        console.log('Regional admin - total users found:', querySnapshot.size)
        querySnapshot.forEach(doc => {
          const userData = doc.data();
          console.log('User data:', userData.name, userData.type, userData.client)
          if (userData?.type !== 'tenant' && (userData?.type === 'regional' || userData?.type === 'officer')) {
            users.push({id: doc.id, ...userData})
            console.log('Added user:', userData.name, userData.type)
          }
        })
        console.log('Regional admin - filtered users:', users.length)
        dispatch({ type: actionConstants.LOADED_USERS, payload: users})
      })
      .catch(error => console.log(error))
  } else {
    return firebase
      .firestore()
      .collection('users')
      .where('client', '==', getState().user.user.client)
      .get()
      .then(querySnapshot => {
        let users = [];
        querySnapshot.forEach(doc => {
          if (doc.data()?.type !== 'tenant') {
            users.push({id: doc.id, ...doc.data()})
          }
        })
        dispatch({ type: actionConstants.LOADED_USERS, payload: users})
      })
      .catch(error => console.log(error))
  }
} 

  

export const getLiveUsers = (userId) => async (dispatch, getState) => {
  dispatch({ type: actionConstants.LOADING_USERS });
  let currentUser = await firebase.auth().currentUser;

  if (getState().user.user.type === 'super') {
    return firebase
    .firestore()
    .collection('users')
    .onSnapshot(querySnapshot => {
      let users = [];
      querySnapshot.forEach(doc => {
        if (doc.data()?.type !== 'tenant') {
          users.push({id: doc.id, ...doc.data()})
        }
      })
      dispatch({ type: actionConstants.LOADED_USERS, payload: users})
    })
  } else if (getState().user.user.type === 'regional') {
    // Regional admins can only see other regional admins and enforcement officers from their client
    return firebase
      .firestore()
      .collection('users')
      .where('client', '==', getState().user.user.client)
      .onSnapshot(querySnapshot => {
        let users = [];
        console.log('Regional admin live - total users found:', querySnapshot.size)
        console.log('Regional admin client:', getState().user.user.client);
        
        // Debug: Show all user types in the database
        const userTypes = new Set();
        const allUsers = [];
        querySnapshot.forEach(doc => {
          const userData = doc.data();
          userTypes.add(userData.type);
          allUsers.push({id: doc.id, ...userData});
        });
        console.log('User types found in database:', Array.from(userTypes));
        console.log('All users in database:', allUsers);
        
        querySnapshot.forEach(doc => {
          const userData = doc.data();
          console.log('Live user data:', userData.name, userData.type, userData.client, 'Active:', userData.active)
          if (userData?.type !== 'tenant' && (userData?.type === 'regional' || userData?.type === 'officer' || userData?.type === 'citation_admin') && userData?.active !== false) {
            users.push({id: doc.id, ...userData})
            console.log('Added live user:', userData.name, userData.type)
          } else {
            console.log('Filtered out user:', userData.name, userData.type, '- reason: tenant or not regional/officer or inactive')
          }
        })
        console.log('Regional admin live - filtered users:', users.length)
        dispatch({ type: actionConstants.LOADED_USERS, payload: users})
      })
  } else {
    return firebase
      .firestore()
      .collection('users')
      .where('client', '==', getState().user.user.client)
      .onSnapshot(querySnapshot => {
        let users = [];
        querySnapshot.forEach(doc => {
          if (doc.data()?.type !== 'tenant') {
            users.push({id: doc.id, ...doc.data()})
          }
        })
        dispatch({ type: actionConstants.LOADED_USERS, payload: users})
      })
  }
};

export const getLiveTenants = (userId) => async (dispatch, getState) => {
  dispatch({ type: actionConstants.LOADING_TENANTS });
  let currentUser = await firebase.auth().currentUser;

  if (getState().user.user.type === 'super') {
    return firebase
    .firestore()
    .collection('users')
    .onSnapshot(querySnapshot => {
      let tenants = [];
      querySnapshot.forEach(doc => {
        if (doc.data()?.type === 'tenant' && doc.data().active) {
          tenants.push({id: doc.id, ...doc.data()})
        }
      })
      dispatch({ type: actionConstants.LOADED_TENANTS, payload: tenants})
    })
  } else {
    return firebase
      .firestore()
      .collection('users')
      .where('client', '==', getState().user.user.client)
      .onSnapshot(querySnapshot => {
        let tenants = [];
        querySnapshot.forEach(doc => {
          if (doc.data()?.type === 'tenant' && doc.data().active) {
            tenants.push({id: doc.id, ...doc.data()})
          }
        })
        dispatch({ type: actionConstants.LOADED_TENANTS, payload: tenants})
      })
  }
};

export const getTenants = () => async (dispatch, getState) => {
  dispatch({ type: actionConstants.LOADING_TENANTS });
  let currentUser = await firebase.auth().currentUser;

  if (getState().user.user.type === 'super') {
    return firebase
    .firestore()
    .collection('users')
    .get()
    .then(querySnapshot => {
      let tenants = [];
      querySnapshot.forEach(doc => {
        if (doc.data()?.type === 'tenant' && doc.data().active) {
          tenants.push({id: doc.id, ...doc.data()})
        }
      })
      dispatch({ type: actionConstants.LOADED_TENANTS, payload: tenants})
    })
    .catch(error => console.log(error))
  } else {
    return firebase
      .firestore()
      .collection('users')
      .where('client', '==', getState().user.user.client)
      .get()
      .then(querySnapshot => {
        let tenants = [];
        querySnapshot.forEach(doc => {
          if (doc.data()?.type === 'tenant' && doc.data().active) {
            tenants.push({id: doc.id, ...doc.data()})
          }
        })
        dispatch({ type: actionConstants.LOADED_TENANTS, payload: tenants})
      })
      .catch(error => console.log(error))
  }
} 

export const getLocationTenants = (location) => async (dispatch, getState) => {
  dispatch({ type: actionConstants.LOADING_TENANTS });

  return firebase
    .firestore()
    .collection('users')
    .where('location', '==', location.id)
    .where('type', '==', 'tenant')
    .where('active', '==', true)
    .get()
    .then(querySnapshot => {
      let tenants = [];
      querySnapshot.forEach(doc => {
        tenants.push({id: doc.id, ...doc.data()})
      })
      dispatch({ type: actionConstants.LOADED_TENANTS, payload: tenants})
    })
    .catch(error => console.log(error))
} 

/**
 * Add a user
 *
 * @param data
 * @returns {function(*, *): Promise<FirebaseFirestoreTypes.DocumentReference>}
 */
 export const addUser = (data, callback) => {
  return async (dispatch, getState) => {
    dispatch({type: actionConstants.ADDING_USER});
    let alreadyExists = await firebase
        .firestore()
        .collection('users')
        .where('email', '==', data.email.toLowerCase())
        .get()
        .then(querySnapshot => {
          return querySnapshot.size > 0
        })
    if (alreadyExists) {
      dispatch({type: actionConstants.ADDING_USER_FAILED, payload: 'A user already exists with that email address'});
      return; // Return early if user already exists
    }    
    try {
      console.log('Creating user with data:', { email: data.email.toLowerCase(), password: data.password ? '[HIDDEN]' : 'MISSING' });
      const createUserResponse = await axios.post('https://us-central1-enforceplus-25667.cloudfunctions.net/createUser', {email: data.email.toLowerCase(), password: data.password})
      console.log('Create user response status:', createUserResponse.status);
      
      if (createUserResponse.status === 200) {
        const uid = createUserResponse.data.uid
        const userData = {
          name: data.name,
          email: data.email.toLowerCase(),
          client: data.client,
          type: data.type,
          active: data.active,
          stripe_refunds: data.stripe_refunds === true,
          ...(data.type === 'regional' && { assignedLocations: data.assignedLocations || [] })
        };
        console.log('Saving user data to Firestore:', userData);
        return firebase
          .firestore()
          .collection('users')
          .doc(uid)
          .set(userData)
          .then(doc => {
            console.log('User saved to Firestore successfully:', uid);
            dispatch({
              type: actionConstants.ADDED_USER,
              payload: {id: uid, user: getState().user.user.id, ...userData},
            });
            callback && callback({id: uid, user: getState().user.user.id, ...userData})
          });
      } else {
        callback && callback()
      }
    } catch (error) {
      console.error('Error creating user:', error);
      dispatch({type: actionConstants.ADDING_USER_FAILED, payload: 'Failed to create user: ' + error.message});
      callback && callback();
    }
  };
};

/**
 * Edit a user
 *
 * @param data
 * @returns {function(*, *): Promise<FirebaseFirestoreTypes.DocumentReference>}
 */
export const editUser = (user, data, callback) => {
  return async (dispatch, getState) => {
    dispatch({type: actionConstants.UPDATING_USER});
    const userData = {
      name: data.name,
      email: data.email,
      client: data.client,
      type: data.type,
      active: data.active,
      // OOB-540: per-user Stripe refund capability, read by createStripeDashboardSession.
      stripe_refunds: data.stripe_refunds === true,
      ...(data.type === 'regional' && { assignedLocations: data.assignedLocations || [] })
    };
    if (data.email && user.id === getState().user.user.id) {
      await firebase.auth().currentUser.updateEmail(data.email.toLowerCase())
    }
    return firebase
      .firestore()
      .collection('users')
      .doc(user.id)
      .update(userData)
      .then(doc => {
        dispatch({
          type: actionConstants.UPDATED_USER,
          payload: {id: user.id, user: getState().user.user.id, ...userData},
        });
        callback && callback({id: user.id, user: getState().user.user.id, ...userData})
      });
  };
};

/**
 * Add a tenant
 *
 * @param data
 * @returns {function(*, *): Promise<FirebaseFirestoreTypes.DocumentReference>}
 */
export const addTenant = (data, callback) => {
  return async (dispatch, getState) => {
    dispatch({type: actionConstants.ADDING_TENANT});
    
    // Check if user already exists with this email
    const existingUserSnapshot = await firebase
        .firestore()
        .collection('users')
        .where('email', '==', data.email.toLowerCase())
        .get();
    
    let existingUser = null;
    if (existingUserSnapshot.size > 0) {
      existingUser = {
        id: existingUserSnapshot.docs[0].id,
        ...existingUserSnapshot.docs[0].data()
      };
      
      // If user exists and is active, fail
      if (existingUser.active) {
        dispatch({type: actionConstants.ADDING_TENANT_FAILED, payload: 'A user already exists with that email address'});
        return;
      }
    }
    
    let uid;
    
    // If we have an existing inactive user, reuse their UID, otherwise create new user
    if (existingUser && !existingUser.active) {
      uid = existingUser.id;
    } else {
      const createUserResponse = await axios.post('https://us-central1-enforceplus-25667.cloudfunctions.net/createUser', {email: data.email.toLowerCase(), password: data.password})
      if (createUserResponse.status === 200) {
        uid = createUserResponse.data.uid;
      } else {
        callback && callback();
        return;
      }
    }
    
    const userData = {
      name: data.name,
      email: data.email.toLowerCase(),
      client: data.client,
      type: "tenant",
      active: true,
      location: data.location || null,
      zone: data.zone || null,
      vehicle_limit: data.vehicle_limit || null,
      created_at: data.created_at || null,
      created_by: data.created_by || null,
    };
    
    return firebase
      .firestore()
      .collection('users')
      .doc(uid)
      .set(userData)
      .then(async (doc) => {
        dispatch({
          type: actionConstants.ADDED_TENANT,
          payload: {id: uid, user: getState().user.user.id, ...userData},
        });
        let thisLocation = getState().location?.locations?.find(loc => loc.id === data.location)
        let locationName = thisLocation?.name || ''
        let locationAddress = thisLocation?.address1 + ', ' + thisLocation?.city
        let clientName = getState().client?.clients?.find(cli => cli.id === data.client)?.name
        let emailSend = await emailjs.send("service_cghbh4g","template_ecc93ie", {
          name: data.name,
          to_email: data.email.toLowerCase(),
          location_name: locationName,
          location_address: locationAddress,
          client_name: clientName
        }, 'Bdnrcb9nkMG24q1Uv');
        callback && callback({id: uid, user: getState().user.user.id, ...userData})
      });
  };
};

/**
 * Edit a tenant
 *
 * @param data
 * @returns {function(*, *): Promise<FirebaseFirestoreTypes.DocumentReference>}
 */
export const editTenant = (tenant, data) => {
  return (dispatch, getState) => {
    const userData = {
      name: data.name,
      location: data.location,
      vehicle_limit: data.vehicle_limit,
    };
    
    // Only include zone and allowedZones if they have values
    if (data.zone !== null && data.zone !== undefined) {
      userData.zone = data.zone;
    }
    if (data.allowedZones !== null && data.allowedZones !== undefined) {
      userData.allowedZones = data.allowedZones;
    }
    return firebase
      .firestore()
      .collection('users')
      .doc(tenant.id)
      .update(userData)
      .then(doc => {
        dispatch(getTenants());
      });
  };
};

/**
 * Remove a tenant
 *
 * @param data
 * @returns {function(*, *): Promise<FirebaseFirestoreTypes.DocumentReference>}
 */
export const softDeleteTenant = (tenant) => {
  return async (dispatch, getState) => {
    return firebase
      .firestore()
      .collection('users')
      .doc(tenant.id)
      .update({
        active: false
      })
      .then(doc => {
        dispatch(getTenants());
      });
  };
};


export const impersonate = (userId) => {
  return async (dispatch, getState) => {    
    dispatch({type: actionConstants.IMPERSONATING});    
    const authImpersonate = firebase.functions().httpsCallable('authImpersonate')    
    try {
      console.log('Starting impersonation for user:', userId);
      console.log('Current user:', getState().user.user);
      
      const originalUserResult = await authImpersonate({userId: getState().user.user.id});
      console.log('Original user result:', originalUserResult);
      dispatch({type: actionConstants.IMPERSONATING_SAVE_TOKEN, payload: originalUserResult.data.token});
      
      const impersonatedUserResult = await authImpersonate({userId});
      console.log('Impersonated user result:', impersonatedUserResult);
      firebase.auth().signInWithCustomToken(impersonatedUserResult.data.token).then(() => {
        dispatch({type: actionConstants.IMPERSONATED, payload: impersonatedUserResult.data.impersonatedUser});
      })
    } catch (error) {
      console.error('Impersonation error:', error);
      console.error('Error details:', error.message, error.code, error.details);
      dispatch({type: actionConstants.IMPERSONATE_FAILED});
    }
  };
}

export const stopImpersonate = () => {
  return async (dispatch, getState) => {    
    dispatch({type: actionConstants.IMPERSONATING});
    firebase.auth().signInWithCustomToken(getState().user.impersonatedOriginalToken).then(() => {
      dispatch({type: actionConstants.IMPERSONATE_STOPPED});
      
      // Force a page reload to clear all filter states when stopping impersonation
      window.location.reload();
    })
  };
}

/**
 * Fix existing tenants that don't have the active field set
 * This is a one-time fix for existing tenants
 */
export const fixExistingTenants = () => {
  return async (dispatch, getState) => {
    try {
      const tenantsSnapshot = await firebase
        .firestore()
        .collection('users')
        .where('type', '==', 'tenant')
        .get();
      
      const batch = firebase.firestore().batch();
      let updateCount = 0;
      
      tenantsSnapshot.forEach(doc => {
        const data = doc.data();
        console.log('Tenant data:', doc.id, data);
        if (data.active === undefined || data.active === null) {
          console.log('Fixing tenant:', doc.id, data.name);
          batch.update(doc.ref, { active: true });
          updateCount++;
        }
      });
      
      if (updateCount > 0) {
        await batch.commit();
        console.log(`Fixed ${updateCount} tenants`);
      } else {
        console.log('No tenants needed fixing');
      }
    } catch (error) {
      console.error('Error fixing tenants:', error);
    }
  };
}

/**
 * Set a password for a specific tenant
 * This is useful for fixing tenants that don't have passwords
 */
export const setTenantPassword = (tenantEmail, newPassword) => {
  return async (dispatch, getState) => {
    try {
      console.log('Setting password for tenant:', tenantEmail);
      
      // First, find the tenant in Firestore
      const tenantQuery = await firebase
        .firestore()
        .collection('users')
        .where('email', '==', tenantEmail.toLowerCase())
        .where('type', '==', 'tenant')
        .get();
      
      if (tenantQuery.empty) {
        console.error('Tenant not found:', tenantEmail);
        return;
      }
      
      const tenantDoc = tenantQuery.docs[0];
      console.log('Found tenant:', tenantDoc.id, tenantDoc.data());
      
      // Update the password in Firebase Auth
      // Note: This requires admin privileges, so we'll use a Cloud Function
      const setPasswordResponse = await axios.post('https://us-central1-enforceplus-25667.cloudfunctions.net/setUserPassword', {
        email: tenantEmail.toLowerCase(),
        password: newPassword
      });
      
      if (setPasswordResponse.status === 200) {
        console.log('Password set successfully for tenant:', tenantEmail);
        // Also ensure the tenant is active
        await tenantDoc.ref.update({ active: true });
        console.log('Tenant marked as active');
      } else {
        console.error('Failed to set password for tenant:', tenantEmail);
      }
    } catch (error) {
      console.error('Error setting tenant password:', error);
    }
  };
}

/**
 * Check if a user exists in Firebase Auth
 * This helps debug authentication issues
 */
export const checkUserInFirebaseAuth = (email) => {
  return async (dispatch, getState) => {
    try {
      console.log('Checking if user exists in Firebase Auth:', email);
      
      // Try to get user by email (this requires admin privileges)
      const response = await axios.post('https://us-central1-enforceplus-25667.cloudfunctions.net/checkUserExists', {
        email: email.toLowerCase()
      });
      
      if (response.status === 200) {
        console.log('User exists in Firebase Auth:', response.data);
        return response.data;
      } else {
        console.log('User not found in Firebase Auth');
        return null;
      }
    } catch (error) {
      console.error('Error checking user in Firebase Auth:', error);
      return null;
    }
  };
}

/**
 * Create Firebase Auth user for existing Firestore user
 * This fixes the case where user exists in Firestore but not in Firebase Auth
 */
export const createFirebaseAuthUser = (email, password) => {
  return async (dispatch, getState) => {
    try {
      console.log('Creating Firebase Auth user for:', email);
      
      const response = await axios.post('https://us-central1-enforceplus-25667.cloudfunctions.net/createUser', {
        email: email.toLowerCase(),
        password: password
      });
      
      if (response.status === 200) {
        console.log('Firebase Auth user created successfully:', response.data);
        return response.data;
      } else {
        console.error('Failed to create Firebase Auth user');
        return null;
      }
    } catch (error) {
      console.error('Error creating Firebase Auth user:', error);
      return null;
    }
  };
}

/**
 * Add a user
 *
 * @param data
 * @returns {function(*, *): Promise<FirebaseFirestoreTypes.DocumentReference>}
 */
export const moveLocations = (data, callback) => {
  return async (dispatch, getState) => {
    dispatch({ type: actionConstants.UPDATING_CLIENT });

    const originalClientRef = firebase.firestore()
      .collection('clients')
      .doc(data.originalClient);

    const newClientRef = firebase.firestore()
      .collection('clients')
      .doc(data.newClient);

    try {
      // Check if locations exist
      const locationsSnapshot = await originalClientRef.collection('locations').get();
      const locationIds = locationsSnapshot.docs.map(doc => doc.id);
      const invalidLocations = data.locations.filter(loc => !locationIds.includes(loc));

      if (invalidLocations.length > 0) {
        dispatch({ type: actionConstants.ADDING_USER_FAILED, payload: 'Locations do not exist on the original client' });
        return;
      }

      // Helper function to move subcollections
      const moveSubcollections = async (subcollections, sourceLocationRef, targetLocationRef) => {
        for (const sub of subcollections) {
          const subcollectionSnapshot = await sourceLocationRef.collection(sub).get();
          for (const doc of subcollectionSnapshot.docs) {
            await targetLocationRef.collection(sub).doc(doc.id).set(doc.data());
          }
        }
      };

      // Subcollections to process
      const subcollections = ['activities', 'tickets', 'violations', 'whitelist'];

      // Move locations and their subcollections
      for (const loc of data.locations) {
        const sourceLocationRef = originalClientRef.collection('locations').doc(loc);
        const targetLocationRef = newClientRef.collection('locations').doc(loc);

        const locationSnapshot = await sourceLocationRef.get();
        if (locationSnapshot.exists) {
          await targetLocationRef.set({...locationSnapshot.data(), client: data.newClient});

          // Move all subcollections
          await moveSubcollections(subcollections, sourceLocationRef, targetLocationRef);

          // Delete the original location
          await sourceLocationRef.delete();
        }
      }

      dispatch({ type: actionConstants.UPDATED_CLIENT });
      callback && callback();
    } catch (error) {
      console.error('Error moving locations:', error);
      dispatch({ type: actionConstants.ADDING_USER_FAILED, payload: 'An error occurred while moving locations' });
    }
  };
};